import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { xapi } from '../../hooks/session';
import { IEmp } from '../../models/emp';
import { throwError } from '../helper';

/*
 * Education Office
 */

/*
 * Rank
 */
export const getEducationOfficeReadRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/rank/read?month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeWalkRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/rank/walk?month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeWriteRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/rank/write?month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadEducationOfficeRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/rank/${data.type}/download?month=${data.month}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'education_office_stat_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * School Stat
 */
export const getEducationOfficeSchoolList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/school?seq=${data.educationOfficeSeq}&schoolGroupSeq=${data.schoolGroupSeq}&schoolSeq=${data.schoolSeq}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}&sortByMember=${data.sortByMember}&sortByFinish=${data.sortByFinish}&sortByAvg=${data.sortByAvg}&sortByTotal=${data.sortByTotal}&sortByWrite=${data.sortByWrite}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

/*
 * Statistics
 */

export const getEducationOfficeMonthlyReadStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-stat/read?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyWalkStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-stat/walk?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyWriteStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-stat/write?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyMemberList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-member?seq=${data.educationOfficeSeq}&year=${data.year}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyReadMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-medal/read?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyWalkMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-medal/walk?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyWriteMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-medal/write?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeReadAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/achievement-stat/read?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeWalkAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/achievement-stat/walk?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeWriteAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/achievement-stat/write?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeDailyReadAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/daily-achievement-stat/read?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeDailyWalkAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/daily-achievement-stat/walk?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeDailyWriteAchievementStat = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/daily-achievement-stat/write?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/achievement-data/read?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/achievement-data/walk?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeMonthlyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/achievement-data/write?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeDailyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/daily-achievement-data/read?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeDailyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/daily-achievement-data/walk?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getEducationOfficeDailyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/daily-achievement-data/write?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadEducationOfficeMonthlyDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-stat/${data.type}/${data.dataType}/download?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'education_office_monthly_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadEducationOfficeMonthlyMedalDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-medal/${data.type}/${data.dataType}/download?seq=${data.educationOfficeSeq}&year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'education_office_monthly_medal.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadEducationOfficeMonthlyMemberData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/monthly-member/download?seq=${data.educationOfficeSeq}&year=${data.year}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'education_office_monthly_member.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Log Manage
 */
export const getEducationOfficeWriteList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/all-write-status?seq=${data.educationOfficeSeq}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadEducationOfficeWriteList = async (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/education-office-stat/all-write-status/download?seq=${data.educationOfficeSeq}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'education_office_stat_log.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });
